import { render, staticRenderFns } from "./login-v2.vue?vue&type=template&id=027e3a8b"
import script from "./login-v2.vue?vue&type=script&lang=js"
export * from "./login-v2.vue?vue&type=script&lang=js"
import style0 from "./login-v2.vue?vue&type=style&index=0&id=027e3a8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports